(function () {
  'use strict';

  var copy = {
    valueMissing: 'Please complete this field.',
    emailMismatch: 'Please enter a valid email address.',
    urlMismatch: 'Please enter a valid web address.',
    patternMismatch: 'Please use the requested format.',
    tooShort: 'Please enter a little more information.',
    tooLong: 'Please shorten this entry.',
    rangeUnderflow: 'Please choose a higher value.',
    rangeOverflow: 'Please choose a lower value.',
    stepMismatch: 'Please choose a valid value.',
    badInput: 'Please enter a valid value.',
    fallback: 'Please review this field.'
  };

  function messageFor(field) {
    var validity = field.validity;
    if (!validity) return copy.fallback;
    if (validity.valueMissing) return field.type === 'email' ? 'Please enter your email address.' : copy.valueMissing;
    if (validity.typeMismatch) return field.type === 'email' ? copy.emailMismatch : copy.urlMismatch;
    if (validity.patternMismatch) return copy.patternMismatch;
    if (validity.tooShort) return copy.tooShort;
    if (validity.tooLong) return copy.tooLong;
    if (validity.rangeUnderflow) return copy.rangeUnderflow;
    if (validity.rangeOverflow) return copy.rangeOverflow;
    if (validity.stepMismatch) return copy.stepMismatch;
    if (validity.badInput) return copy.badInput;
    return copy.fallback;
  }

  document.addEventListener('invalid', function (event) {
    var field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) return;
    field.setCustomValidity('');
    if (!field.validity.valid) field.setCustomValidity(messageFor(field));
  }, true);

  document.addEventListener('input', function (event) {
    var field = event.target;
    if (field && typeof field.setCustomValidity === 'function') field.setCustomValidity('');
  }, true);

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (field && typeof field.setCustomValidity === 'function') field.setCustomValidity('');
  }, true);
})();
